import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DirectorsTab from "@/components/setup/DirectorsTab";
import CategoriesTab from "@/components/setup/CategoriesTab";
import PaymentMethodsTab from "@/components/setup/PaymentMethodsTab";
import FinancialYearsTab from "@/components/setup/FinancialYearsTab";
import CurrencyTab from "@/components/setup/CurrencyTab";
import TestDataTab from "@/components/setup/TestDataTab";

const TABS = [
  { value: "directors", label: "Directors", C: DirectorsTab },
  { value: "categories", label: "Categories", C: CategoriesTab },
  { value: "payment-methods", label: "Payment methods", C: PaymentMethodsTab },
  { value: "financial-years", label: "Financial years", C: FinancialYearsTab },
  { value: "currency", label: "Currency", C: CurrencyTab },
  { value: "test-data", label: "Test data", C: TestDataTab },
];

export default function SetupPage() {
  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="setup-title">Setup</h1>
      <p className="mt-3 text-muted-foreground text-base md:text-lg">Directors, categories, payment methods and financial years.</p>
      <Tabs defaultValue="directors" className="mt-10">
        <TabsList className="h-auto flex-wrap justify-start bg-card border border-border rounded-xl p-1">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} data-testid={`setup-tab-${t.value}`}
              className="rounded-lg data-[state=active]:bg-accent data-[state=active]:text-foreground">{t.label}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(({ value, C }) => (
          <TabsContent key={value} value={value} className="mt-8"><C /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
